import { atom, useRecoilState } from 'recoil';
import { localStorageEffect } from 'libs/recoil';
import { LOCAL_STORAGE_KEY } from 'state/localStorage';

export const COORDINATE_FORMATS = ['decimal', 'DDM', 'DMS'] as const;

export type CoordinateFormat = (typeof COORDINATE_FORMATS)[number];

type CoordinateFormatState = {
  coordinateFormat: CoordinateFormat;
  setCoordinateFormat: (format: CoordinateFormat) => void;
};

export const coordinateFormatAtom = atom<CoordinateFormat>({
  key: LOCAL_STORAGE_KEY.COORDINATE_FORMAT,
  default: 'decimal',
  effects: [localStorageEffect(LOCAL_STORAGE_KEY.COORDINATE_FORMAT)],
});

export const useCoordinateFormatState = (): CoordinateFormatState => {
  const [coordinateFormat, setCoordinateFormat] =
    useRecoilState(coordinateFormatAtom);

  return { coordinateFormat, setCoordinateFormat };
};
